// src/layouts/MainLayout.js
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../components/Footer/Footer';
import Navbar from '../components/navigationbar/Navbar';

const MainLayout = () => {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  // Define paths where Navbar and Footer should be hidden
  const hideNavbar = ['/login', '/forgot-password', '/register', '/gpcon2025', '/registration-form', '/registration-success'].some(p => path.startsWith(p));
  const hideFooter = ['/login', '/forgot-password', '/register'].some(p => path.startsWith(p));

  return (
    <div className="app-layout">
      {!hideNavbar && <Navbar />}
      <main className="app-main-content">
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default MainLayout;

